import { render, staticRenderFns } from "./SponsorPackage.vue?vue&type=template&id=4d2115da&scoped=true&"
import script from "./SponsorPackage.vue?vue&type=script&lang=js&"
export * from "./SponsorPackage.vue?vue&type=script&lang=js&"
import style0 from "./SponsorPackage.vue?vue&type=style&index=0&id=4d2115da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2115da",
  null
  
)

export default component.exports